import styled from 'styled-components';

import Cluster from './Cluster';

const StyledCluster = styled(Cluster)`
    position: relative;
    color: #fff;
    border-radius: 50%;
    padding: 1.5rem;
    background: ${(props) => props.theme.colours.primary};
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    font-size: 1.5rem;
    transition: background 125ms ease;
    &::before,
    &::after {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        transition: opacity 125ms ease;
    }
    &::before {
        opacity: 1;
        box-shadow: 0 0 0 0.5rem ${(props) => props.theme.colours.primary}33;
    }
    &::after {
        box-shadow: 0 0 0 0.5rem ${(props) => props.theme.colours.secondary}33;
        opacity: 0;
    }
    &:hover {
        background: ${(props) => props.theme.colours.secondary};
        &::before {
            opacity: 0;
        }
        &::after {
            opacity: 1;
        }
    }
`;

export default StyledCluster;
